const menuToggle = document.querySelector('.menu-toggle');
const navLinks = document.querySelector('.nav-links');

menuToggle?.addEventListener('click', () => {
  const open = navLinks.classList.toggle('open');
  menuToggle.setAttribute('aria-expanded', String(open));
  menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
});

navLinks?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    navLinks.classList.remove('open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    menuToggle?.setAttribute('aria-label', 'Open menu');
  });
});

document.querySelectorAll('[data-filter]').forEach((button) => {
  button.setAttribute('aria-pressed', String(button.classList.contains('active')));
  button.addEventListener('click', () => {
    document.querySelectorAll('[data-filter]').forEach((item) => {
      item.classList.remove('active');
      item.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('active');
    button.setAttribute('aria-pressed', 'true');
    const selected = button.dataset.filter;
    document.querySelectorAll('.catalog-card').forEach((card) => {
      card.classList.toggle('hidden', selected !== 'all' && card.dataset.category !== selected);
    });
  });
});


// Add the business number in international format (digits only) when it is provided.
const WHATSAPP_NUMBER = document.body.dataset.whatsapp || '';
const whatsappIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 11.6a8.5 8.5 0 0 1-12.4 7.5L3.5 20.5l1.5-4.4a8.5 8.5 0 1 1 15.5-4.5Z"/><path d="M8.4 8.2c.3-.3.6-.3.8 0l1.1 1.5c.2.3.1.5-.1.8l-.5.6c.6 1.1 1.6 2.1 2.7 2.7l.6-.5c.3-.2.5-.3.8-.1l1.5 1.1c.3.2.3.5 0 .8-.8.8-1.8 1-2.8.6a9.7 9.7 0 0 1-5.3-5.3c-.4-1-.2-2 .6-2.8Z"/></svg>';

if (/^\d{8,15}$/.test(WHATSAPP_NUMBER)) {
  const link = document.createElement('a');
  link.className = 'whatsapp-float';
  link.href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hello, I would like to discuss an activewear manufacturing project.')}`;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.setAttribute('aria-label', 'Contact GM Apparel Manufacturing on WhatsApp');
  link.innerHTML = `${whatsappIcon}<span>Chat on WhatsApp</span>`;
  document.body.append(link);
} else {
  const panel = document.createElement('div');
  panel.className = 'whatsapp-panel';
  panel.id = 'whatsapp-panel';
  panel.innerHTML = '<h3>WhatsApp contact</h3><p>Direct WhatsApp chat will be available when the business number is connected. You can review the enquiry page now.</p><a class="btn" href="/pages/contact">Go to Contact Page</a>';
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'whatsapp-float';
  button.setAttribute('aria-label', 'WhatsApp contact options');
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-controls', 'whatsapp-panel');
  button.innerHTML = `${whatsappIcon}<span>WhatsApp</span>`;
  button.addEventListener('click', () => {
    const open = panel.classList.toggle('open');
    button.setAttribute('aria-expanded', String(open));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      panel.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
    }
  });
  document.body.append(panel, button);
}
